/**
 * Pre-Picked Curbside — full article page for the "Pre-Picked Curbside"
 * sharing option under Urban Harvest.
 *
 * Route: /food-pulse/urban-harvest/pre-picked-curbside
 */
import { Trees } from "lucide-react";
import UrbanHarvestArticleLayout, { UH_PALETTE } from "@/components/UrbanHarvestArticleLayout";

export default function FoodPulseUrbanHarvestPrePickedCurbside() {
  return (
    <UrbanHarvestArticleLayout
      slug="pre-picked-curbside"
      title="Pre-Picked Curbside"
      subtitle="Easy Sharing Without Visitors on Your Property"
      icon={Trees}
      accent={UH_PALETTE.amber}
      body={[
        "Some homeowners are happy to share their harvest but prefer not to have visitors enter their property. The Pre-Picked Curbside option was designed with convenience, privacy, and simplicity in mind.",
        "Simply harvest your surplus fruits or vegetables, place them in clearly marked boxes or containers near your curb, driveway, porch, or another designated pickup location, and update your FoodPulse listing.",
        "FoodPulse will notify interested recipients or approved pickup partners that fresh produce is ready for collection. Once the pickup is completed, your listing is automatically updated, helping prevent unnecessary trips and reducing waste.",
        "This approach allows homeowners to participate comfortably while maintaining their privacy. There is no need to schedule appointments or coordinate access to your backyard.",
        "Fresh produce moves quickly from your garden to families who can enjoy it, all while minimizing food waste and maximizing convenience.",
      ]}
      pullquote="Sharing your harvest can be as easy as placing a box by the curb."
    />
  );
}
